import { render, staticRenderFns } from "./InvitesEdit.vue?vue&type=template&id=4082daa7&"
import script from "./InvitesEdit.vue?vue&type=script&lang=js&"
export * from "./InvitesEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvitesEdit.vue?vue&type=style&index=0&id=4082daa7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports